import ProjectsList from "./ProjectsList";
import Wrapper from "./Wrapper";

export default {
  ProjectsList,
  Wrapper
};
